import React from 'react';

import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {useCanCreateAaMonomersAndRedirect} from './useCanCreateAaMonomers';

export default function AaMonomerCreationMethodPicker(): JSX.Element {
  const {isLoading} = useCanCreateAaMonomersAndRedirect();

  if (isLoading) {
    return <CenteredHorizontalThrobber />;
  }

  return <div>Creation method picker</div>;
}
